export default `
<div class="animated fadeIn">
<h2>1.</h2>
<table border='1' bordercolor='black' width='100%' height='250' align='center'>
	<tr>
		<th>프로젝트 명</th>
		<td>PHP 게시판</td>
	</tr>
	<tr>
		<th>개발환경</th>
		<td>PHP 7, Apache, Mysql 5.7 </td>
	</tr>
	<tr>
		<th>프로젝트 개요</th>
		<td>PHP를 사용한 간단한 CRUD 게시판과 Pusher를 사용한 실시간 채팅 프로젝트입니다.</td>
	</tr>
	<tr>
		<th>Git 주소</th>
		<td><a href='https://github.com/a2175/PHPproject' target='_blank'>https://github.com/a2175/PHPproject</a></td>
	</tr>
	<tr>
	<th>Demo</th>
		<td><a href='http://a2175.iptime.org/php/'
			target='_blank'>http://a2175.iptime.org/php/</a></td>
	</tr>
	<tr>
		<th colspan='2' align='center' bgcolor='#CCEEFF' height='20'>상세내용</th>
	</tr>
</table>

<table width='100%' height='1'>
<tr>
<td>

<img src='http://${window.location.hostname}/img/2-1.png' style='width: 60%; height: auto;'>
<img src='http://${window.location.hostname}/img/2-2.png' style='width: 70%; height: auto;'>

개인 블로거의 글을 참고하여 CSS를 그대로 가져와 스프링 프로젝트를 본따 MVC 구조로 간단한 CRUD 게시판을 구축했습니다.

</td>
</tr>
</table>` +

/* ------------------------------------------------------------------------------------------ */

`
<br><br><br><br>
<h2>2.</h2>
<table border='1' bordercolor='black' width='100%' height='250' align='center'>
	<tr>
		<th>프로젝트 명</th>
		<td>Laravel 게시판</td>
	</tr>
	<tr>
		<th>개발환경</th>
		<td>PHP 7, Laravel 5.8, Mysql 5.7 </td>
	</tr>
	<tr>
		<th>프로젝트 개요</th>
		<td>Laravel를 사용한 간단한 CRUD 게시판과 Pusher를 사용한 실시간 채팅 프로젝트입니다.</td>
	</tr>
	<tr>
		<th>Git 주소</th>
		<td><a href='https://github.com/a2175/LaravelProject' target='_blank'>https://github.com/a2175/LaravelProject</a></td>
	</tr>
	<tr>
	<tr>
		<th colspan='2' align='center' bgcolor='#CCEEFF' height='20'>상세내용</th>
	</tr>
</table>

<table width='100%' height='1'>
<tr>
<td>

<img src='http://${window.location.hostname}/img/2-3.jpg' style='width: 80%; height: auto;'>
Laravel을 사용해 앞의 PHP 게시판과 Pusher 채팅 기능을 똑같이 구현한 프로젝트입니다.

</td>
</tr>
</table>
</div>
`
